// extracted by mini-css-extract-plugin
module.exports = {"noScrollbar":"Tab_noScrollbar__Ykcaj"};